// Do not fabricate zero counts when the API is unavailable or still an old version.
export function parseProductStats(value) {
  if (!value || typeof value !== 'object') return null;
  const keys = ['total', 'active', 'inactive', 'out_of_stock'];
  if (keys.some(key => !Number.isSafeInteger(value[key]) || value[key] < 0)) return null;
  if (value.active + value.inactive !== value.total || value.out_of_stock > value.active) return null;
  return Object.fromEntries(keys.map(key => [key, value[key]]));
}
